export type BookingSummaryDisplayConfigInput = {
  isMobile: boolean;
  clubSupportsPrivateBookings: boolean;
  isPrivateLessonRequest: boolean;
  isLessonBooking: boolean;
};

export type BookingSummaryDisplayConfig = {
  shouldShowChargesSummary: boolean;
  shouldShowBookingPayment: boolean;
  shouldShowFooter: boolean;
};

export const getBookingSummaryDisplayConfig = (
  input: BookingSummaryDisplayConfigInput
): BookingSummaryDisplayConfig => {
  const { isMobile, clubSupportsPrivateBookings } = input;

  // In private booking flow we never show price surfaces.
  const shouldShowChargesSummary = isMobile && !clubSupportsPrivateBookings;
  const shouldShowBookingPayment = !isMobile && !clubSupportsPrivateBookings;
  const shouldShowFooter = isMobile || clubSupportsPrivateBookings;

  return {
    shouldShowChargesSummary,
    shouldShowBookingPayment,
    shouldShowFooter,
  };
};
